<template>
  <div class="d-profile text-dark">
    <template v-if="schoolIsFromDenmark">
      <Loader v-if="!theUser || !schoolId"></Loader>
      <template v-else>
        <div class="marg-1-top"></div>
        <ProfileSubjects
          class="marg-1-top"
          :canEdit="isUserCanEdit"
          :schoolId="schoolId"
          :user="user">
        </ProfileSubjects>
      </template>
    </template>
  </div>
</template>

<script>
import Loader from '../common/Loader'
import ProfileSubjects from './ProfileSubjects'

export default {
  components: {ProfileSubjects, Loader},
  props: {
    userId: {
      default: null
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolIsFromDenmark () {
      const school = this.$store.state.activeSchool
      return school && school.country === 'DK'
    },
    user () {
      return this.$store.state.user
    },
    theUser () {
      if (!this.user) {
        return null
      }
      if (this.userId * 1 === this.user.id * 1) {
        return this.user
      }
      return this.allUsersInHash && this.allUsersInHash[this.userId] ? this.allUsersInHash[this.userId] : null
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    isUserCanEdit () {
      if (this.userId * 1 === this.user.id * 1) {
        return true
      }
      return this.userHasPermission('can_manage_users')
    },
    users () {
      return this.$store.state.allUsers
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    }
  },
  methods: {
    userHasPermission (val) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(val) > -1 || this.user.admin
      } else {
        return true
      }
    }
  }
}
</script>

<style :scoped>
.d-profile {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Profile.vue?0daa4cc8